import { AssetTransferMethodEnum, TransferStatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { IsOptional, Matches, MaxLength } from "class-validator";

export class TransferIdRequest {
    @ApiProperty()
    assetTransferId: number;
    @ApiProperty()
    updatedUser:string;
    @ApiProperty()
    receivedDate:Date;
    @ApiProperty()
    updatedUserId:number;
}